const AddCircleIcon = () => (
  <svg
    width='25'
    height='25'
    viewBox='0 0 25 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    {' '}
    <mask
      id='mask0_1646_604'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='25'
      height='25'
    >
      {' '}
      <rect x='0.5' y='0.942261' width='24' height='24' fill='#D9D9D9' />{' '}
    </mask>{' '}
    <g mask='url(#mask0_1646_604)'>
      {' '}
      <path
        d='M12 17.4423H13V13.4423H17V12.4423H13V8.44226H12V12.4423H8V13.4423H12V17.4423ZM12.5034 21.9423C11.2588 21.9423 10.0887 21.7061 8.9931 21.2338C7.89748 20.7615 6.94444 20.1204 6.13397 19.3107C5.32352 18.501 4.68192 17.5489 4.20915 16.4543C3.73638 15.3597 3.5 14.1901 3.5 12.9456C3.5 11.7011 3.73616 10.531 4.20848 9.43536C4.68081 8.33974 5.32183 7.3867 6.13153 6.57624C6.94123 5.76579 7.89337 5.12418 8.98795 4.65141C10.0826 4.17864 11.2521 3.94226 12.4966 3.94226C13.7412 3.94226 14.9113 4.17842 16.0069 4.65074C17.1025 5.12307 18.0556 5.76409 18.866 6.57379C19.6765 7.38349 20.3181 8.33563 20.7908 9.43021C21.2636 10.5248 21.5 11.6944 21.5 12.9389C21.5 14.1835 21.2638 15.3535 20.7915 16.4492C20.3192 17.5448 19.6782 18.4978 18.8685 19.3083C18.0588 20.1187 17.1066 20.7603 16.012 21.2331C14.9174 21.7059 13.7479 21.9423 12.5034 21.9423ZM12.5 20.9423C14.7333 20.9423 16.625 20.1673 18.175 18.6173C19.725 17.0673 20.5 15.1756 20.5 12.9423C20.5 10.7089 19.725 8.81726 18.175 7.26726C16.625 5.71726 14.7333 4.94226 12.5 4.94226C10.2667 4.94226 8.375 5.71726 6.825 7.26726C5.275 8.81726 4.5 10.7089 4.5 12.9423C4.5 15.1756 5.275 17.0673 6.825 18.6173C8.375 20.1673 10.2667 20.9423 12.5 20.9423Z'
        fill='#1C3A13'
      />{' '}
    </g>{' '}
  </svg>
);

export default AddCircleIcon;
